export default __webpack_public_path__ + "static/media/icn-braking-distance.7e4f4eb8.svg";